"use strict";

exports.__esModule = true;
exports["default"] = SocialYoutube;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialYoutube(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M511 485.5c0 14.1-11.4 25.5-25.5 25.5h-459C12.4 511 1 499.6 1 485.5v-459C1 12.4 12.4 1 26.5 1h459C499.6 1 511 12.4 511 26.5v459zM256 137.7c-165.7 0-165.7 0-165.7 117.4s0 117.4 165.7 117.4 165.7 0 165.7-117.4 0-117.4-165.7-117.4zm-36.3 165.7v-96.6l93.2 48.3-93.2 48.3z",
    fill: "#939496"
  }));
}